export const PrimaryColor = "linear-gradient(90deg, #ca9937, #e0b15a)";
